import React from 'react';
import { Lock, RotateCcw, Zap } from 'lucide-react';
export function MidCTA() {
  return <section className="py-12 md:py-16 bg-[radial-gradient(ellipse_at_center,#1a0e00_0%,#0a0a0a_80%)] border-y border-[rgba(201,151,43,.15)] text-center" data-id="element-217">
      <div className="container" data-id="element-218">
        <img src="https://cdn.magicpatterns.com/uploads/1h3VDWWxaasGSK6jtYC35k/IA6.png" alt="Código Oscuro — Solo Hoy $6.36 USD" className="mx-auto mb-8 w-[320px] md:w-[400px] rounded-xl drop-shadow-[0_0_40px_rgba(201,151,43,.35)]" data-id="element-219" />
        <div className="section-label justify-center" data-id="element-220">
          No lo dejes para después
        </div>
        <h3 className="font-playfair text-[clamp(1.5rem,3vw,2.2rem)] text-blanco mb-2.5" data-id="element-221">
          ¿Ya sabes que lo necesitas?
          <br data-id="element-222" />
          No esperes más.
        </h3>
        <p className="text-gris-texto mb-7 text-[.93rem]" data-id="element-223">
          Más de 4.000 personas ya están aplicando estas técnicas. El precio
          sube pronto.
        </p>

        <div className="flex items-center justify-center gap-3.5 mb-7 max-sm:flex-col max-sm:gap-1.5" data-id="element-224">
          <span className="text-[1.2rem] text-rojo-vivo line-through font-semibold" data-id="element-225">
            Valor: $57 USD
          </span>
          <span className="font-playfair text-[2.4rem] font-black text-dorado-claro" data-id="element-226">
            $6.36 USD
          </span>
        </div>

        <a href="https://rutinaspracticas.com/cart/52921322438978:1" className="btn-primary animate-shimmer text-[14px] p-[18px_44px] inline-flex items-center justify-center" data-id="element-227">
          Acceder ahora con garantía
        </a>

        <div className="flex flex-wrap justify-center gap-3.5 text-xs text-gris-texto mt-5" data-id="element-228">
          <span className="flex items-center gap-1.5" data-id="element-229">
            <Lock className="w-3.5 h-3.5 text-dorado" data-id="element-230" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-231">
            <RotateCcw className="w-3.5 h-3.5 text-dorado" data-id="element-232" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-233">
            <Zap className="w-3.5 h-3.5 text-dorado" data-id="element-234" /> Acceso inmediato
          </span>
        </div>
      </div>
    </section>;
}